import { ErrorConfig } from '../base';
import i18n from '@/helper/i18n';
import globalMessageStore from '@/store/common/global-message';

const t = i18n.chain;

const getAACheckoutErrorKey = (error: any) => error.message || '';
const getErrorMessage = (messageKey: string): string => {
  return t.error.aaCheckoutExceptions?.[messageKey];
};

export const aaCheckoutExceptionConfig: ErrorConfig<any> = {
  'Invalid time value': {
    getErrorKey: getAACheckoutErrorKey,
    handleError: (error) => {
      const message = getErrorMessage('Invalid time value');
      message && globalMessageStore.show(message);
    },
  },
  default: {
    getErrorKey: getAACheckoutErrorKey,
    handleError: (error) => {
      const { message } = error;
      message && globalMessageStore.show(message);
    },
  },
};
